export const REACTIONS = [
    {
        id: ':lolol:',
        code: '😂',
    },
    {
        id: ':thumbsup:',
        code: '👍',
    },
    {
        id: ':fire:',
        code: '🔥',
    },
    {
        id: ':raisedhand:',
        code: '✋',
    },
    {
        id: ':heart:',
        code: '❤️️',
    },
];
//# sourceMappingURL=reactions.js.map